import styled from 'styled-components';

export const Logo = styled.img`
  ${props => `width: ${props.iconOnly ? 48 : 150}px;`}
  ${props => (props.dark ? 'filter: invert(0.8);' : '')}
`;
